import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/EditorialMarquee";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { Reviews } from "@/components/site/Reviews";
import { Contact } from "@/components/site/Contact";
import { Availability } from "@/components/site/Availability";
import { FloatingCTA } from "@/components/site/FloatingCTA";
import { AuthProvider } from "@/admin/AuthContext";
import { ProtectedRoute } from "@/admin/ProtectedRoute";
import AdminLogin from "@/admin/AdminLogin";
import Dashboard from "@/admin/Dashboard";
import ClientDetail from "@/admin/ClientDetail";
import AdminCalendar from "@/admin/AdminCalendar";

function PublicSite() {
  return (
    <SmoothScroll>
      <div className="App bg-cream" data-testid="patolas-app">
        <Navbar />
        <main>
          <Hero />
          <EditorialMarquee />
          <Services />
          <Manifesto />
          <Reviews />
          <Availability />
          <Contact />
        </main>
        <FloatingCTA />
      </div>
    </SmoothScroll>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicSite />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/admin/calendario" element={<ProtectedRoute><AdminCalendar /></ProtectedRoute>} />
          <Route path="/admin/clients/:id" element={<ProtectedRoute><ClientDetail /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
